<template>
  <div id="bul" class="container-fluid">
      <div class="row p-0 ps-4 pe-4 h-100">
        <div class="col d-flex align-items-center justify-content-center">
          <input class="ara form-control form-control-sm" type="text" placeholder="Belgelerde Ara" aria-label="Belgelerde Ara" v-model="ara_isim_anahtar">


          <div v-if="!tarihe_gore_ara" style="width: fit-content;"><button class="btn btn-sm" style="white-space: nowrap !important; margin-left: 10px !important;" @:click="this.tarihe_gore_ara = true">Tarih Filtresi</button></div>
            <div v-if="tarihe_gore_ara && !this.miladi_ara && !this.hicri_ara"  style=" margin-left: 10px;">
              
              <button  class="btn btn-sm" style="white-space: nowrap !important; margin-left: 4px !important;" @:click="this.hicri_ara= true; this.miladi_ara = false;">Hicri Takvim</button>
            </div>
              <div v-if="tarihe_gore_ara && !this.miladi_ara && !this.hicri_ara"  style=" margin-left: 10px;">
              <button class="btn btn-sm" style="white-space: nowrap !important; margin-left: 4px !important; " @:click="this.miladi_ara = true; this.hicri_ara= false">Miladi Takvim</button>
       
            </div>
            <div v-if="tarihe_gore_ara && hicri_ara" style="width: 200px; margin-right: 10px; margin-left: 10px;">
            <select class="form-select form-control  form-select-sm" v-model="ara_ay">
              <option v-for="(item, index) in hicri_aylar" :value="item.deger"  :key="index">{{ item.adi }} </option>
            </select>
          </div>
          <div v-if="tarihe_gore_ara && hicri_ara"   style="width: 200px;">
            <select class="form-select form-control  form-select-sm" v-model="ara_yil">
              <option v-for="(item, index) in hicri_yillar" :value="item.deger"  :key="index">{{ item.adi }} </option>
            </select>
          </div>



          <div v-if="tarihe_gore_ara && miladi_ara" style="width: 200px; margin-right: 10px; margin-left: 10px;">
            <select class="form-select form-control  form-select-sm" v-model="ara_ay">
              <option v-for="(item, index) in miladi_aylar" :value="item.deger"  :key="index">{{ item.adi }} </option>
            </select>
          </div>

          <div v-if="tarihe_gore_ara && miladi_ara"   style="width: 200px;">
            <select class="form-select form-control  form-select-sm" v-model="ara_yil">
              <option v-for="(item, index) in miladi_yillar" :value="item.deger"  :key="index">{{ item.adi }} </option>
            </select>
          </div>

          <div v-if="tarihe_gore_ara && (miladi_ara || hicri_ara)"   style="width: 50px;" class="d-flex align-items-center justify-content-center">
           <span class="p-2" style="cursor: pointer; color: #616C72; font-weight: 700;" @:click="
           this.ara_yil = '';
           this.ara_ay = '';
           this.miladi_ara = false,
           this.hicri_ara = false,
           this.tarihe_gore_ara = false;
           ">X</span>
         </div>



        </div>
      </div>
    </div>

 
    

    <div class="container-fluid">
      <div class="row p-4">
  
      
  
    <div class='row' ref="tablocontainer">
      <div class="col-lg-12 ofset-lg-2">
        <div id="datalar" class="table-responsice" v-if="liste && liste_hazir">
          <DataTable class="table table-stripeds table-bordereds display"
          style="width:100%"
          :data="filteredList"
          :columns="stunlar"
          :options="datatablesettings"
          >
            <thead>
      <tr>
        <th v-for="(item, index) in stunlar" :key="index">{{item.name}}</th>
      </tr>
      </thead>
      </DataTable>
      </div>
    </div>
  
  </div>
  </div>
  </div>
  
  </template>
  
<script>
  
  import axios from 'axios'
  import 'jquery'
  import DataTable from 'datatables.net-vue3'
  import DataTableLib from 'datatables.net-bs5'
  import responsible from 'datatables.net-responsive-bs5'
  import 'datatables.net-bs5/css/dataTables.bootstrap5.css'
  import 'datatables.net-buttons-bs5/css/buttons.bootstrap5.css'
  import jquery from 'jquery'

  DataTable.use(DataTableLib)
  DataTable.use(responsible)
 
  const columns = [
  { data: 'id',name:'Sıra No' },
  { data: 'belge_no',name:'Belge No' },
  { data: 'belge_adeti',name:'Belge' },
  { data: 'miladi',name:'Miladi' },
  { data: 'hicri',name:'Hicri' },
  { data: 'aciklama',name:'Özet'}
  ];
  
  
  export default {
  name: 'BoaListeler',
  self : this,
  components: {
    DataTable
  },
  data () {
    return {
      scrollX: true,
      products:null,
      stunlar:columns,
      datatablesettings:{
        autoWidth:true,
        select:true,
        searching: false,
        ordering: false,
        dom:'Bfrtip',
        "language":{url: "./datatable-tr.json"},
        
          order: [ 3, 'asc' ],
  
          drawCallback: function () {
        
          jquery('.paginate_button:not(.disabled)', this.api().table().container())          
            .on('click', function(){
                //alert('next');
                //BoaListeler.test()
            });       
   
          },
          responsive: true,
  
          columnDefs: [
            {type: 'turkish',
                targets: this.sutun_ayarlari(),
                visible: false,
            }
          
          ]
      },
      liste:false,
      liste_hazir:false,
      ara_ay:"",
      ara_yil:"",
      ara_isim_anahtar:"",
      hicri_yillar:[],
      miladi_yillar:[], 
      hicri_aylar : [
        {"adi":"Tüm Aylar","deger":""},
        {"adi":"Muharrem (1.Ay)","deger":"01"},
        {"adi":"Safer (2.Ay)","deger":"02"},
        {"adi":"Rebiülevvel (3.Ay)","deger":"03"},
        {"adi":"Rebiülahir (4.Ay)","deger":"04"},
        {"adi":"Cemaziyelevvel (5.Ay)","deger":"05"},
        {"adi":"Cemaziyelahir (6.Ay)","deger":"06"},
        {"adi":"Recep (7.Ay)","deger":"07"},
        {"adi":"Şaban (8.Ay)","deger":"08"},
        {"adi":"Ramazan (9.Ay)","deger":"09"},
        {"adi":"Şevval(10.Ay)","deger":"10"},
        {"adi":"Zilkade (11.Ay)","deger":"11"},
        {"adi":"Zilhicce (12.Ay)","deger":"12"}
      ],
      miladi_aylar : [
        {"adi":"Tüm Aylar","deger":""},
        {"adi":"Ocak","deger":"01"},
        {"adi":"Şubat","deger":"02"},
        {"adi":"Mart","deger":"03"},
        {"adi":"Nisan","deger":"04"},
        {"adi":"Mayıs","deger":"05"},
        {"adi":"Haziran","deger":"06"},
        {"adi":"Temmuz","deger":"07"},
        {"adi":"Ağustos","deger":"08"},
        {"adi":"Eylül","deger":"09"},
        {"adi":"Ekim","deger":"10"},
        {"adi":"Kasım","deger":"11"},
        {"adi":"Aralık","deger":"12"}
      ],
      tarihe_gore_ara:false,
      hicri_ara:false,
      miladi_ara:false,
      window_h:null
      }
      },
      computed: {
        filteredList() {
          
            return this.liste.filter(items => {
                return String(items.ay_hicri).includes(this.ara_ay)
                && String(items.yil_hicri).includes(this.ara_yil)
                && (items.keys.toLowerCase().includes(this.ara_isim_anahtar.toLowerCase()) || items.aciklama.toLowerCase().includes(this.ara_isim_anahtar.toLowerCase()))
                })
                
        },
        

      
      
    },
    mounted() {
    //window.addEventListener("resize", this.myEventHandler);
    window.addEventListener("click", this.myClicks);
    
    },
    unmounted() {
     // window.removeEventListener("resize", this.myEventHandler);
    window.removeEventListener("click", this.myClicks);
    },
    created (){
      this.liste_getir()
      this.dedectTableHeight()
     
    },
    
    watch: {
      
      ara_isim_anahtar: function (newValue, oldValue) {
        if(newValue != oldValue){
          if(newValue != " "){
          //this.marked()
          this.highlight()
          this.set_hicri_yillar()
          //this.footerSet()
        }
        }
    },
    window_h: function(newH, oldH){
      if(newH != oldH){
          //alert();
        }
     
    },
    
  },
    methods: {
      set_hicri_yillar: function(){
          function onlyUnique(value, index, array) {
            return array.indexOf(value) === index;
          }
            var h_yil_list = []
            this.filteredList.forEach(element => {
              h_yil_list.push(element.yil_hicri)
            });          

          var unique = h_yil_list.filter(onlyUnique);

          unique.sort(function(a, b) {
            return a - b;
          });
          
          
          var new_uniq = [{"adi":"Hepsi","deger":""}]
          unique.forEach(element => {
            new_uniq.push({"adi":String(element),"deger":String(element)})
          });
          this.hicri_yillar = new_uniq

        
          
          return false
        },
      dedectTableHeight() {
      //this.window_h = this.$refs.tablocontainer.clientHeight;
  

    },
     /* myEventHandler(e) {
        this.window_h = e.target.innerHeight;
        
      },
      */
      myClicks(e) {      
          if((typeof e.target.attributes.class !== 'undefined') && e.target.attributes.class["value"] === 'page-link'){
              this.highlight()
          }
      },
      
      bhb: function(str) {
          var specialLetters = { "i": "İ", "ş": "Ş", "ğ": "Ğ", "ü": "Ü", "ö": "Ö", "ç": "Ç", "ı": "I" };
          var letters = { "İ": "i", "I": "ı", "Ş": "ş", "Ğ": "ğ", "Ü": "ü", "Ö": "ö", "Ç": "ç" };
          var arr = str.split(' ');
          for (var i = 0; i < arr.length; i++) {
              arr[i] = arr[i].charAt(0).replace(/(([iışğüçö]))/g, function (letter) { return specialLetters[letter]; }).toUpperCase() + arr[i].substr(1).replace(/(([İIŞĞÜÇÖ]))/g, function (letter) { return letters[letter]; }).toLowerCase();
          }
          return arr.join(" ");
      },
      footerSet (){
        alert()
        var tbl_h = jquery("#datalar").height()
        var window_h = jquery(window).innerHeight()
        if(tbl_h - 50 < window_h){
          jquery("#footer").addClass("footer")
        } else {
          jquery("#footer").removeClass("footer")
        }
  
      },
  highlight: function(){
    var aranan = this.ara_isim_anahtar
    if(aranan.trim() !== ""  ){
    setTimeout(() => {
      
          
          jquery('td').each(function() {
            var temizlestep1 = jquery(this).text();
            var marktemizle =  temizlestep1.replaceAll("<mark>","")
              var temiztext =  marktemizle.replaceAll("<mark>","")     
    //let textToSearch = this.ara_isim_anahtar;
    //var paragraph = jquery(this);
    var textToSearch = aranan.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

    let pattern = new RegExp(`${textToSearch}`,"gi");
    
    //paragraph.innerHTML = paragraph.textContent.replace(pattern, match =>`<mark>${match}</mark>`);
    var newtext = temiztext.replace(pattern, match =>`<mark>${match}</mark>`);
    jquery(this).html(newtext)
  })

    }, 0)
  }
  },
      
      marked: function(){
        setTimeout(() => {
        if(this.ara_isim_anahtar !== " "){
          var aranan = this.ara_isim_anahtar
          
          jquery('td').contents().filter(function() {
          return this.nodeType == 2
          }).each(function(){
              this.textContent = this.textContent.replace(aranan,"<span class=\"isaretle\">"+aranan+"</span>");
          });

        }
      },500)
          
       
      
      },
      liste_getir: function () {
        const formData = new FormData()
        //formData.append('hicri_ay', this.hicri_ay)
        axios({
          method: 'post',
          responseType: 'json',
          url: 'islemler.php',
          data: formData
        }).then((response) => {
          this.liste = response.data.boa_data
          this.hicri_yillar = response.data.hicri_yillar
          this.miladi_yillar = response.data.miladi_yillar
          this.liste_hazir = true
          
        })
      },
      getCookie: function (cname){
        var name = cname + "=";
        var decodedCookie = decodeURIComponent(document.cookie);
        var ca = decodedCookie.split(';');
          for(var i = 0; i <ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
              }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
          }
        return "";
      },
      setCookie: function (cname, cvalue, exdays){
        var d = new Date();
        d.setTime(d.getTime() + (exdays*24*60*60*1000));
        var expires = "expires="+ d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
      },
      sutun_ayarlari: function(){
  
        var sutunlar = this.getCookie("sutunlar").split(',').map(Number);
        if(this.getCookie("sutunlar").length > 0){
        return sutunlar
        } else {
          const default_sutunlar = ''
          return default_sutunlar.split(',').map(Number);
        }
      }
    }
  }
  </script>
<style scope>
#bul{
  height: 66px !important;
  background-color: #364856;
}
.ara{
  max-width: 600px;
}
input[type="text"],select, button.btn{
  border:1px solid #616C72;
  box-shadow:none !important;
  background-color: #4D6877;
  outline: none !important;
}
button.btn:hover{ background-color: #487e9c;}
input[type="text"]:focus-visible, select {
outline: none;
box-shadow:none !important;
border:1px solid #616C72;
background-color: rgb(171, 171, 171) !important;
transition: all .28s;
}
.footer {
    position: fixed;
    height: 100px;
    bottom: 0;
    width: 100%;
}
#header{background-color: #f1f2f2;
padding-bottom: 26px !important;}
.logo{ width: 300px !important;}
mark{ padding: 0px !important; background-color: rgba(0,0,0,0) !important; 
  color:rgb(230, 20, 118) !important; font-weight: 700 !important;}
  .ikonnew{
  margin-right: 8px;
  }
  
  h1 span{
  font-weight: 400;
  }
  
  h1{
  
  font-weight: 700;
  
  
  }
  
  table th{
  font-size: 16px;
  }
  
  table td{
    font-family: proxima-nova, sans-serif;
  font-weight: 400;
  font-style: normal;
  }
  th:nth-child(1){
    width: 120px;
  }
  th:nth-child(3), th:nth-child(4){
    width: 120px;
  }
  
  .isaretle{
    font-weight: 700;

  color:rgb(230, 20, 118);
}



</style>  